import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=637e48e4"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports